import React from "react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import { DataSertifikatTte } from "@/types"
import { MoreHorizontal } from "lucide-react"
import { Link } from "react-router-dom"

export default function Actions({ row }: { row: DataSertifikatTte }) {
  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem>
              <Link to={row.url_local_file} target="_blank">
                Download File
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Link to={row.url_tte_file} target="_blank">
                Download File TTE
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </React.Fragment>
  )
}
